<button class="btn btn_primary btn_loading loading">
  <div class="txt">{{ 'common.downloading' | translate }}</div>
  <div class="l_animation">
    <span class="bar"> </span>
    <span class="bar"> </span>
    <span class="bar"> </span>
    <span class="bar"> </span>
  </div>
</button>
